var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"space-y-8"},[_c('page-header',{attrs:{"hide-breadcrumbs":"","description":"Add static questions and answers. Note: After every update, the language model needs to be uploaded again."}}),_c('qna-items-list-card',{attrs:{"bot":_vm.bot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }